window.theme = window.theme || {};

(function() {
  'use strict';

  // Dates with no dispatch, regardless of day of week: UK bank holidays +
  // the Christmas/New Year shutdown. Review and update this list annually.
  var EXCLUSION_DATES = [
    // 2026 UK bank holidays (England & Wales)
    '2026-01-01', // New Year's Day
    '2026-04-03', // Good Friday
    '2026-04-06', // Easter Monday
    '2026-05-04', // Early May bank holiday
    '2026-05-25', // Spring bank holiday
    '2026-08-31', // Summer bank holiday
    '2026-12-25', // Christmas Day
    '2026-12-28', // Boxing Day (substitute, 26 Dec falls on a Saturday)
    // Christmas / New Year shutdown, 24 Dec - 2 Jan inclusive
    '2026-12-24',
    '2026-12-26',
    '2026-12-27',
    '2026-12-29',
    '2026-12-30',
    '2026-12-31',
    '2027-01-01',
    '2027-01-02'
  ];

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function isoDate(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  function isExcluded(date) {
    return EXCLUSION_DATES.indexOf(isoDate(date)) !== -1;
  }

  function dateOnly(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  // Sun = 0 ... Sat = 6
  function isDispatchDay(date) {
    if (date.getDay() === 0) return false;
    if (isExcluded(date)) return false;
    return true;
  }

  function getUkNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  }

  function weekdayName(date) {
    return date.toLocaleDateString('en-GB', { weekday: 'long' });
  }

  function findNextDispatchDay(fromDate) {
    var d = dateOnly(fromDate);
    d.setDate(d.getDate() + 1);
    while (!isDispatchDay(d)) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function getDispatchCountdownText(cutoffHour) {
    var now = getUkNow();
    var today = dateOnly(now);

    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    var todayIsDispatchDay = isDispatchDay(today);

    if (todayIsDispatchDay && now < cutoff) {
      var totalMinutes = Math.max(0, Math.ceil((cutoff - now) / 60000));
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      var hoursLabel = hours === 1 ? 'hr' : 'hrs';
      var minutesLabel = minutes === 1 ? 'min' : 'mins';
      var timeText = hours > 0 ? (hours + ' ' + hoursLabel + ' ' + minutes + ' ' + minutesLabel) : (minutes + ' ' + minutesLabel);
      return 'In stock. Order within ' + timeText + ' for dispatch today';
    }

    // "Tomorrow" only applies when today is a normal Mon-Fri dispatch day
    // (i.e. we're past cutoff on a weekday) and tomorrow is itself a valid
    // dispatch day. Saturdays, Sundays, and excluded dates always name the
    // next dispatch day explicitly instead (e.g. "dispatch Monday").
    var todayIsNormalWeekday = today.getDay() >= 1 && today.getDay() <= 5 && !isExcluded(today);
    var tomorrow = dateOnly(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (todayIsNormalWeekday && isDispatchDay(tomorrow)) {
      return 'In stock. Order now for dispatch tomorrow';
    }

    var nextDispatchDay = findNextDispatchDay(now);
    return 'In stock. Order now for dispatch ' + weekdayName(nextDispatchDay);
  }

  theme.setDispatchCountdownText = function(el) {
    if (!el) return;
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 15;
    el.textContent = getDispatchCountdownText(cutoffHour);
  };

  function updateAll() {
    document.querySelectorAll('[data-dispatch-countdown]').forEach(theme.setDispatchCountdownText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  setInterval(updateAll, 30000);
})();
